import { render } from "./AddInstitute.vue?vue&type=template&id=efd48fb2&scoped=true"
import script from "./AddInstitute.vue?vue&type=script&lang=js"
export * from "./AddInstitute.vue?vue&type=script&lang=js"

import "./AddInstitute.vue?vue&type=style&index=0&id=efd48fb2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-efd48fb2"

export default script